import { Button, useToast } from '@chakra-ui/react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import ColorsTable from '../../../components/Colors/ColorsTable.js';
import { columnsDataColors } from './variables/columnsDataColors.js';
import React, { useEffect, useState } from 'react';
import { getData, postData, putData } from '../../../utils/httpClient.js'; // Asegúrate de importar postData
import { useSearch } from '../../../contexts/SearchContext.js';
import ColorsEditModal from '../../../components/Colors/ColorsEditModal.js'; // Asegúrate de importar el modal
import { useResetPageOnFilterChange } from '../../../hooks/useResetPageOnFilterChange.js';
import { useTableSorting } from '../../../hooks/useTableSorting.js';

export default function Settings() {
  const { searchQuery, resetListFilters } = useSearch(); 
  const [data, setData] = useState([]); 
  const [page, setPage] = useState(0); 
  const [totalPages, setTotalPages] = useState(0); 
  const [modalState, setModalState] = useState({ isOpen: false, color: null, isNew: false });
  const [rowsPerPage, setRowsPerPage] = useState(10); 
  const toast = useToast();
  const { sorting, setSorting, sortBy, sortDir, appendSortParams } = useTableSorting();

  useResetPageOnFilterChange(setPage, page, [searchQuery, rowsPerPage, sortBy, sortDir]);


  const loadData = async (dato) => {
    try {
      const params = new URLSearchParams({
        page: String(page + 1),
        limit: String(rowsPerPage),
        data: dato || '',
      });
      appendSortParams(params);
      const response = await getData(`/colors?${params.toString()}`);
      setData(response?.payload?.colors || []); // Actualiza los datos
      setTotalPages(Math.ceil(response?.payload?.total / rowsPerPage));
    } catch (error) {
      console.error('Error fetching colors:', error);
    }
  };

  useEffect(() => {
    loadData(searchQuery);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchQuery, rowsPerPage, sortBy, sortDir]);

  useEffect(() => {
    resetListFilters();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openNewColorModal = () => {
    setModalState({ isOpen: true, color: null, isNew: true });
  };

  const closeEditModal = () => {
    setModalState({ isOpen: false, color: null, isNew: false });
  };

  // Función para crear un nuevo color
  const handleCreateColor = async (newColor) => {
    try {
      await postData('/colors', newColor); 
      loadData(searchQuery);
    } catch (error) {
      toast({
        title: 'Error al obtener colors',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Función para actualizar un color
  const handleUpdateColor = async (updatedColor) => {
    try {
      await putData(`/colors/${updatedColor.id}`, updatedColor); // Actualiza el color en la API
      await loadData(searchQuery); 
      closeEditModal(); 
    } catch (error) {
      toast({
        title: 'Error al actualizar el color',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <AdminPageShell
      title="Colores"
      actions={
        <Button variant="adminPrimary" size="sm" onClick={openNewColorModal}>
          Nuevo color
        </Button>
      }
    >
      <ColorsTable
          columnsData={columnsDataColors}
          data={data} 
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageSize={rowsPerPage}
          setPageSize={setRowsPerPage}
          handleUpdateColor={handleUpdateColor}
          sorting={sorting}
          onSortingChange={setSorting}
        />


      <ColorsEditModal
        isOpen={modalState.isOpen}
        onClose={closeEditModal}
        color={modalState.color}
        isNew={modalState.isNew}
        onCreate={handleCreateColor} 
      />
    </AdminPageShell>
  );
}